var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroidPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195.705,
    height: 59.516,
    viewBox: "0 0 195.705 59.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5900aa;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10515",
    "data-name": "Grupo 10515",
    transform: "translate(-517.828 -557.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9181",
    "data-name": "Trazado 9181",
    className: "cls-1",
    d: "M188.141,59.516H7.565A7.565,7.565,0,0,1,0,51.951V7.565A7.565,7.565,0,0,1,7.565,0H188.141a7.565,7.565,0,0,1,7.565,7.565V51.951a7.565,7.565,0,0,1-7.565,7.565",
    transform: "translate(517.828 557.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9182",
    "data-name": "Trazado 9182",
    className: "cls-2",
    d: "M235.863,128.134h2.729v6.191a8.666,8.666,0,0,1-2.8,1.465,10.728,10.728,0,0,1-3.284.511,8.858,8.858,0,0,1-4.283-1.032,7.663,7.663,0,0,1-3-2.851,8.293,8.293,0,0,1,0-8.21,7.644,7.644,0,0,1,3.007-2.851,8.968,8.968,0,0,1,4.316-1.032,9.426,9.426,0,0,1,3.55.644,6.97,6.97,0,0,1,2.685,1.886l-1.82,1.775a5.837,5.837,0,0,0-4.283-1.775,6.052,6.052,0,0,0-2.918.688,5.014,5.014,0,0,0-2,1.93,5.555,5.555,0,0,0-.721,2.84,5.466,5.466,0,0,0,.721,2.8,5.164,5.164,0,0,0,2,1.953,5.849,5.849,0,0,0,2.9.71,6.25,6.25,0,0,0,3.2-.8Z",
    transform: "translate(346.103 465.075)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9183",
    "data-name": "Trazado 9183",
    className: "cls-2",
    d: "M299.885,147.813a5.66,5.66,0,0,1-2.252-2.164,6.469,6.469,0,0,1,0-6.268,5.685,5.685,0,0,1,2.252-2.153,7.191,7.191,0,0,1,6.5,0,5.689,5.689,0,0,1,2.252,2.153,6.469,6.469,0,0,1,0,6.268,5.663,5.663,0,0,1-2.252,2.164,7.191,7.191,0,0,1-6.5,0m5.769-2.618a4.109,4.109,0,0,0,0-5.37,3.389,3.389,0,0,0-2.53-1.021,3.353,3.353,0,0,0-2.519,1.021,4.144,4.144,0,0,0,0,5.37,3.352,3.352,0,0,0,2.519,1.021,3.388,3.388,0,0,0,2.53-1.021",
    transform: "translate(290.424 452.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9184",
    "data-name": "Trazado 9184",
    className: "cls-2",
    d: "M361.081,147.813a5.66,5.66,0,0,1-2.252-2.164,6.47,6.47,0,0,1,0-6.268,5.685,5.685,0,0,1,2.252-2.153,7.191,7.191,0,0,1,6.5,0,5.688,5.688,0,0,1,2.252,2.153,6.469,6.469,0,0,1,0,6.268,5.663,5.663,0,0,1-2.252,2.164,7.191,7.191,0,0,1-6.5,0m5.769-2.618a4.109,4.109,0,0,0,0-5.37,3.389,3.389,0,0,0-2.53-1.021,3.353,3.353,0,0,0-2.519,1.021,4.144,4.144,0,0,0,0,5.37,3.352,3.352,0,0,0,2.519,1.021,3.388,3.388,0,0,0,2.53-1.021",
    transform: "translate(243.54 452.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9185",
    "data-name": "Trazado 9185",
    className: "cls-2",
    d: "M431.952,136.586v10.052q0,6.257-6.391,6.257a11.852,11.852,0,0,1-3.24-.433,6.877,6.877,0,0,1-2.53-1.254l1.243-2.086A5.939,5.939,0,0,0,423,150.155a7.7,7.7,0,0,0,2.407.388,3.975,3.975,0,0,0,2.862-.888,3.628,3.628,0,0,0,.91-2.707v-.621a4.561,4.561,0,0,1-1.731,1.176,6.1,6.1,0,0,1-2.241.4,6.427,6.427,0,0,1-3.051-.721,5.413,5.413,0,0,1-2.152-2.03,6.067,6.067,0,0,1,0-5.98,5.363,5.363,0,0,1,2.152-2.008,6.51,6.51,0,0,1,3.051-.71,6.261,6.261,0,0,1,2.341.421,4.327,4.327,0,0,1,1.764,1.287v-1.575Zm-3.739,8.022a3.2,3.2,0,0,0,1.01-2.452,3.14,3.14,0,0,0-1.01-2.419,4.082,4.082,0,0,0-5.192,0,3.14,3.14,0,0,0-1.01,2.419,3.2,3.2,0,0,0,1.01,2.452,4.045,4.045,0,0,0,5.192,0",
    transform: "translate(196.656 452.717)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_7727",
    "data-name": "Rect\\xE1ngulo 7727",
    className: "cls-2",
    width: 2.774,
    height: 16.465,
    transform: "translate(632.246 584.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9186",
    "data-name": "Trazado 9186",
    className: "cls-2",
    d: "M524.549,143.4h-9.3a3.221,3.221,0,0,0,1.276,2.075,4.181,4.181,0,0,0,2.563.766,4.319,4.319,0,0,0,3.217-1.287l1.487,1.708a5.007,5.007,0,0,1-2.019,1.443,8,8,0,0,1-6.191-.289,5.589,5.589,0,0,1-2.3-2.164,6.106,6.106,0,0,1-.81-3.14,6.2,6.2,0,0,1,.788-3.118,5.587,5.587,0,0,1,2.186-2.163,6.375,6.375,0,0,1,3.151-.777,6.218,6.218,0,0,1,3.1.765,5.425,5.425,0,0,1,2.13,2.152,6.529,6.529,0,0,1,.765,3.207q0,.288-.044.821m-8.2-3.939a3.316,3.316,0,0,0-1.121,2.1h6.724a3.272,3.272,0,0,0-1.087-2.086,3.307,3.307,0,0,0-2.263-.8,3.346,3.346,0,0,0-2.252.788",
    transform: "translate(125.204 452.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9187",
    "data-name": "Trazado 9187",
    className: "cls-2",
    d: "M612.9,121.938a5.115,5.115,0,0,1,2.3,1.908,5.831,5.831,0,0,1,0,5.891,5.09,5.09,0,0,1-2.3,1.919,8.6,8.6,0,0,1-3.517.666h-3.506V136.8h-2.885V121.272h6.391a8.6,8.6,0,0,1,3.517.666m-.788,7.145a3.163,3.163,0,0,0,0-4.571,4.432,4.432,0,0,0-2.862-.8h-3.373v6.169h3.373a4.432,4.432,0,0,0,2.862-.8",
    transform: "translate(55.858 464.348)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_7728",
    "data-name": "Rect\\xE1ngulo 7728",
    className: "cls-2",
    width: 2.774,
    height: 16.465,
    transform: "translate(674.694 584.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9188",
    "data-name": "Trazado 9188",
    className: "cls-2",
    d: "M703.925,137.707a4.846,4.846,0,0,1,1.387,3.783v6.945h-2.618v-1.442a3.23,3.23,0,0,1-1.453,1.187,5.687,5.687,0,0,1-2.274.41,5.576,5.576,0,0,1-2.33-.455,3.6,3.6,0,0,1-1.542-1.265,3.208,3.208,0,0,1-.544-1.831,3.137,3.137,0,0,1,1.187-2.563,5.894,5.894,0,0,1,3.739-.965h3.062v-.178a2.428,2.428,0,0,0-.743-1.908,3.216,3.216,0,0,0-2.208-.666,6.375,6.375,0,0,0-1.964.311,4.832,4.832,0,0,0-1.631.865l-1.087-2.019a6.733,6.733,0,0,1,2.241-1.087,9.973,9.973,0,0,1,2.774-.377,5.779,5.779,0,0,1,4.005,1.254m-2.53,8.388a2.6,2.6,0,0,0,1.143-1.365v-1.376h-2.862q-2.4,0-2.4,1.576a1.414,1.414,0,0,0,.6,1.2,2.745,2.745,0,0,0,1.664.444,3.58,3.58,0,0,0,1.853-.477",
    transform: "translate(-14.286 452.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9189",
    "data-name": "Trazado 9189",
    className: "cls-2",
    d: "M758.7,137.022l-5.547,12.8a5.961,5.961,0,0,1-1.886,2.718,4.518,4.518,0,0,1-2.685.788,5.519,5.519,0,0,1-1.753-.289,3.878,3.878,0,0,1-1.42-.8l1.109-2.041a3.025,3.025,0,0,0,.943.6,2.885,2.885,0,0,0,1.1.222,1.89,1.89,0,0,0,1.209-.377,3.339,3.339,0,0,0,.877-1.265l.2-.466-5.17-11.894h2.885l3.728,8.765,3.75-8.765Z",
    transform: "translate(-53.248 452.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9190",
    "data-name": "Trazado 9190",
    className: "cls-2",
    d: "M156.84,109.9l-7.457-4.3-6.132,5.928,5.6,5.418,7.984-4.609a1.406,1.406,0,0,0,0-2.434",
    transform: "translate(408.08 476.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9191",
    "data-name": "Trazado 9191",
    className: "cls-2",
    d: "M78.274,56.765l-8.206-4.736L52.086,42.814,72.4,62.447Z",
    transform: "translate(477.924 524.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9192",
    "data-name": "Trazado 9192",
    className: "cls-2",
    d: "M53.362,154.464l17.714-9.759,7.647-4.414-5.349-5.172Z",
    transform: "translate(476.946 453.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9193",
    "data-name": "Trazado 9193",
    className: "cls-2",
    d: "M46.892,46.21l-.019,39.651L67.392,66.026Z",
    transform: "translate(481.917 521.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9194",
    "data-name": "Trazado 9194",
    className: "cls-2",
    d: "M227.8,64.884h3.858a5.638,5.638,0,0,1,2.653.6,4.4,4.4,0,0,1,1.787,1.678,5.063,5.063,0,0,1,0,4.914,4.4,4.4,0,0,1-1.787,1.679,5.638,5.638,0,0,1-2.653.6H227.8Zm3.8,8.61A4.594,4.594,0,0,0,233.782,73a3.591,3.591,0,0,0,1.448-1.367,4.184,4.184,0,0,0,0-4.02,3.59,3.59,0,0,0-1.448-1.367,4.6,4.6,0,0,0-2.179-.494h-2.8v7.743Z",
    transform: "translate(343.305 507.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9195",
    "data-name": "Trazado 9195",
    className: "cls-2",
    d: "M274.017,63.617a.665.665,0,0,1-.2-.487.65.65,0,0,1,.2-.474.681.681,0,0,1,.5-.2.694.694,0,0,1,.5.2.627.627,0,0,1,.2.467.708.708,0,0,1-1.2.5m.014,1.76h.961V72.5h-.961Z",
    transform: "translate(308.052 509.411)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9196",
    "data-name": "Trazado 9196",
    className: "cls-2",
    d: "M287.325,81.717a3.565,3.565,0,0,1-1.239-.63l.433-.758a3.642,3.642,0,0,0,1.124.575,4.461,4.461,0,0,0,1.408.223,2.689,2.689,0,0,0,1.442-.3.969.969,0,0,0,.467-.86.773.773,0,0,0-.257-.616,1.707,1.707,0,0,0-.65-.339,9.4,9.4,0,0,0-1.042-.223,11.908,11.908,0,0,1-1.394-.332,2.046,2.046,0,0,1-.9-.575,1.6,1.6,0,0,1-.372-1.124,1.76,1.76,0,0,1,.745-1.462,3.343,3.343,0,0,1,2.071-.569,5.375,5.375,0,0,1,1.381.183,3.8,3.8,0,0,1,1.137.481l-.42.772a3.594,3.594,0,0,0-2.1-.609,2.435,2.435,0,0,0-1.388.325,1,1,0,0,0-.467.853.842.842,0,0,0,.264.65,1.62,1.62,0,0,0,.656.359,10.523,10.523,0,0,0,1.083.237,12.4,12.4,0,0,1,1.367.325,2.009,2.009,0,0,1,.88.555,1.527,1.527,0,0,1,.366,1.083,1.722,1.722,0,0,1-.778,1.483,3.7,3.7,0,0,1-2.159.548,5.465,5.465,0,0,1-1.658-.25",
    transform: "translate(298.649 500.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9197",
    "data-name": "Trazado 9197",
    className: "cls-2",
    d: "M324.1,75.177a3.245,3.245,0,0,1,1.272,1.279,4.1,4.1,0,0,1,0,3.777,3.255,3.255,0,0,1-1.266,1.28,3.645,3.645,0,0,1-1.821.453,3.367,3.367,0,0,1-1.564-.359,2.963,2.963,0,0,1-1.144-1.049v3.966h-.961V74.778h.921v1.408a2.959,2.959,0,0,1,1.144-1.083,3.356,3.356,0,0,1,1.6-.379,3.659,3.659,0,0,1,1.814.453m-.528,5.591a2.437,2.437,0,0,0,.954-.982,2.99,2.99,0,0,0,.345-1.448,2.952,2.952,0,0,0-.345-1.442,2.5,2.5,0,0,0-.954-.981,2.792,2.792,0,0,0-2.714,0,2.51,2.51,0,0,0-.948.981,2.947,2.947,0,0,0-.345,1.442,2.985,2.985,0,0,0,.345,1.448,2.449,2.449,0,0,0,.948.982,2.84,2.84,0,0,0,2.714,0",
    transform: "translate(273.728 500.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9198",
    "data-name": "Trazado 9198",
    className: "cls-2",
    d: "M356.564,81.5a3.4,3.4,0,0,1-1.3-1.293,3.92,3.92,0,0,1,0-3.736,3.358,3.358,0,0,1,1.3-1.286,3.965,3.965,0,0,1,3.709,0,3.314,3.314,0,0,1,1.293,1.286,3.97,3.97,0,0,1,0,3.736,3.359,3.359,0,0,1-1.293,1.293,3.914,3.914,0,0,1-3.709,0m3.215-.731a2.406,2.406,0,0,0,.941-.982,3.268,3.268,0,0,0,0-2.9,2.407,2.407,0,0,0-.941-.982,2.853,2.853,0,0,0-2.721,0,2.45,2.45,0,0,0-.948.982,3.211,3.211,0,0,0,0,2.9,2.449,2.449,0,0,0,.948.982,2.853,2.853,0,0,0,2.721,0",
    transform: "translate(246.013 500.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9199",
    "data-name": "Trazado 9199",
    className: "cls-2",
    d: "M399.911,75.5a3.041,3.041,0,0,1,.792,2.267V81.9h-.961V77.865a2.361,2.361,0,0,0-.555-1.692,2.086,2.086,0,0,0-1.584-.582,2.434,2.434,0,0,0-1.821.684,2.583,2.583,0,0,0-.67,1.889V81.9h-.961V74.778h.921v1.313a2.674,2.674,0,0,1,1.09-1.008,3.49,3.49,0,0,1,1.618-.359,2.91,2.91,0,0,1,2.132.778",
    transform: "translate(215.858 500.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9200",
    "data-name": "Trazado 9200",
    className: "cls-2",
    d: "M432.614,63.617a.664.664,0,0,1-.2-.487.65.65,0,0,1,.2-.474.681.681,0,0,1,.5-.2.694.694,0,0,1,.5.2.627.627,0,0,1,.2.467.708.708,0,0,1-1.2.5m.014,1.76h.961V72.5h-.961Z",
    transform: "translate(186.546 509.411)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9201",
    "data-name": "Trazado 9201",
    className: "cls-2",
    d: "M454.389,65.776a3.245,3.245,0,0,1,1.273,1.279,4.077,4.077,0,0,1,0,3.763,3.286,3.286,0,0,1-1.273,1.286,3.612,3.612,0,0,1-1.814.46,3.354,3.354,0,0,1-1.6-.379,2.928,2.928,0,0,1-1.144-1.1V72.5h-.921V62.453h.961v4.278a2.965,2.965,0,0,1,1.144-1.049,3.369,3.369,0,0,1,1.564-.359,3.658,3.658,0,0,1,1.814.453m-.528,5.591a2.437,2.437,0,0,0,.954-.982,3.211,3.211,0,0,0,0-2.9,2.439,2.439,0,0,0-.954-.982,2.84,2.84,0,0,0-2.714,0,2.45,2.45,0,0,0-.948.982,3.211,3.211,0,0,0,0,2.9,2.449,2.449,0,0,0,.948.982,2.84,2.84,0,0,0,2.714,0",
    transform: "translate(173.908 509.411)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_7729",
    "data-name": "Rect\\xE1ngulo 7729",
    className: "cls-2",
    width: 0.961,
    height: 10.045,
    transform: "translate(631.993 571.864)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9202",
    "data-name": "Trazado 9202",
    className: "cls-2",
    d: "M507.571,78.637h-5.956a2.544,2.544,0,0,0,.853,1.794,2.83,2.83,0,0,0,1.949.684,3.07,3.07,0,0,0,1.218-.237,2.659,2.659,0,0,0,.961-.7l.541.623a3.05,3.05,0,0,1-1.184.866,4,4,0,0,1-1.564.3,3.954,3.954,0,0,1-1.943-.467,3.367,3.367,0,0,1-1.32-1.293,3.684,3.684,0,0,1-.474-1.868,3.817,3.817,0,0,1,.453-1.868,3.285,3.285,0,0,1,1.246-1.286,3.659,3.659,0,0,1,3.553,0,3.263,3.263,0,0,1,1.232,1.279,3.853,3.853,0,0,1,.447,1.875Zm-5.165-2.43a2.578,2.578,0,0,0-.792,1.712h5.049a2.579,2.579,0,0,0-.792-1.712,2.614,2.614,0,0,0-3.466,0",
    transform: "translate(134.264 500.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9203",
    "data-name": "Trazado 9203",
    className: "cls-2",
    d: "M557.7,78.637H551.74a2.544,2.544,0,0,0,.853,1.794,2.83,2.83,0,0,0,1.949.684,3.069,3.069,0,0,0,1.218-.237,2.66,2.66,0,0,0,.961-.7l.541.623a3.05,3.05,0,0,1-1.184.866,4,4,0,0,1-1.564.3,3.953,3.953,0,0,1-1.943-.467,3.367,3.367,0,0,1-1.32-1.293,3.684,3.684,0,0,1-.474-1.868,3.817,3.817,0,0,1,.453-1.868,3.284,3.284,0,0,1,1.246-1.286,3.659,3.659,0,0,1,3.553,0,3.263,3.263,0,0,1,1.232,1.279,3.852,3.852,0,0,1,.447,1.875Zm-5.165-2.43a2.578,2.578,0,0,0-.792,1.712h5.049A2.579,2.579,0,0,0,556,76.207a2.614,2.614,0,0,0-3.466,0",
    transform: "translate(95.861 500.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9204",
    "data-name": "Trazado 9204",
    className: "cls-2",
    d: "M594.567,75.5a3.041,3.041,0,0,1,.792,2.267V81.9H594.4V77.865a2.361,2.361,0,0,0-.555-1.692,2.087,2.087,0,0,0-1.584-.582,2.434,2.434,0,0,0-1.821.684,2.582,2.582,0,0,0-.67,1.889V81.9h-.961V74.778h.921v1.313a2.674,2.674,0,0,1,1.09-1.008,3.489,3.489,0,0,1,1.618-.359,2.91,2.91,0,0,1,2.132.778",
    transform: "translate(66.726 500.01)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidPink);
export default __webpack_public_path__ + "static/media/android-pink.687b2233.svg";
export { ForwardRef as ReactComponent };